<template>
    <div class="c-comments u-m-b5">
        <comment-box></comment-box>
        <div>
            <post-comments
                v-for="comment in comments"
                :key="comment.comment_id"
                :comment="comment"
            ></post-comments>
            <div @click.prevent="moreComments" v-if="this.$root.commentsTotal > 5 && !showAll" class="u-align-center">
                <button class="c-btn3">More</button>
            </div>
        </div>
    </div>
</template>

<script>
import CommentBox from "./CommentBox";
import PostComments from "./PostComments";

export default {
    components: {
        CommentBox,
        PostComments
    },
    created() {
        this.$root.$on('bus-unshift-comment', (comment) => {
            this.comments.unshift(comment);
        });
        this.$root.$on('bus-unshift-child-comment', (data) => {
            this.traverseComments(this.comments, data);
        });
        this.getComments();
    },
    data() {
        return {
            Networks: this.$simpleStore.Networks,
            comments: null,
            showAll: false
        }
    },
    methods: {
        getComments() {
            // /api/v1/posts/$dyadeyId/comments?user_id={$this->_userId}
            this.$http.get('/api/v1/posts/' + this.$root.dyadey_id + '/comments').then(
                (response) => {
                    this.comments = response.data.comments;
                },
                (response) => {
                    console.log("Errored:");
                    console.log(response);
                }
            );
        },
        traverseComments(comments, data) {
            for (let i = 0; i < comments.length; i++) {
                if (parseInt(comments[i].comment_id) === data.parentId) {
                    comments[i].replies.unshift(data.comment);
                } else if (comments[i].replies.length > 0) {
                    this.traverseComments(comments[i].replies, data);
                }
            }
        },
        moreComments() {
            this.showAll = true;
            //this.comments = this.$root.comments;
        }
    }
}
</script>
